import React, { Component } from 'react'
import '../../../assets/css/WearThatSearch/Gender.scss'

export default class Gender extends Component {
  constructor (props) {
    super(props)
    this.state = {
      filterOptions: {
        women: 'Women',
        men: 'Men'
      }
    }
  }

  render () {
    const { gender_restriction, handleCheckboxChange } = this.props
    const options = []
    for (const key of Object.keys(this.state.filterOptions)) {
      options.push(
        <label key={key} className='fancy-checkbox'>
          <input
            type='checkbox'
            name='gender_restriction'
            onChange={e => handleCheckboxChange(e)}
            checked={gender_restriction.includes(key)}
            value={key}
            key={key}
            className='checkbox'
          />
          <i className='fa   unchecked' />
          <i className='fa fa-check checked' />
          <div className='some-label'>
            {this.state.filterOptions[key]}
          </div>
          <br />
        </label>
      )
    }
    return <div className='gender-wrapper'>{options}</div>
  }
}
